import React, { FC, memo } from 'react'
import { UIPlacement, UISizes, UITypes, BadgeComponent, TooltipComponent } from 'LibNeo'
import { IconStyled, IconComponentStyled, IconLinkStyled } from './styled'

export interface IconProps {
	name: string
	type?: UITypes
	className?: string
	tooltip?: string | JSX.Element
	tooltipPlacement?: UIPlacement
	onClick?: (e: any) => void
	link?: string
	size?: UISizes
	disabled?: boolean
	badge?: number
	defaultVisibleTooltip?: boolean
}

export const IconComponent: FC<IconProps> = memo(
	({
		size = UISizes.NORMAL,
		className,
		onClick,
		tooltip,
		link,
		name,
		type = UITypes.PRIMARY,
		disabled,
		badge,
		tooltipPlacement = UIPlacement.TOP,
		defaultVisibleTooltip,
	}) => {
		const iconItem = (
			<IconStyled size={size} type={type} isAction={Boolean(link || onClick)} disabled={disabled}>
				<use xlinkHref={`#icon-${name}`} />
			</IconStyled>
		)

		const iconWrapper = (
			<IconComponentStyled className={className} size={size} onClick={onClick} disabled={disabled}>
				{iconItem}
			</IconComponentStyled>
		)

		const icon = (): JSX.Element => {
			if (badge) {
				return <BadgeComponent count={badge}>{iconWrapper}</BadgeComponent>
			}
			if (link) {
				return (
					<IconLinkStyled className={className} size={size} to={link}>
						{iconItem}
					</IconLinkStyled>
				)
			}
			return iconWrapper
		}

		return (
			<>
				{tooltip ? (
					<TooltipComponent
						defaultVisible={defaultVisibleTooltip}
						title={tooltip}
						placement={tooltipPlacement}
					>
						{icon()}
					</TooltipComponent>
				) : (
					icon()
				)}
			</>
		)
	}
)
